<template>
    <div>
        <div class="alert alert-success" v-if="saved">
            This result has been saved.
        </div>

        <!--<form v-on:submit.prevent="submit">-->

        <div :class="boxClass.box" v-if="role=='user' || role=='admin' && !memberEntity">

            <div :class="boxClass.boxHeader">
                <div :class="boxClass.title">
                    Member
                </div>
            </div>
            <div :class="boxClass.boxBody">

                <member-search v-model="member" v-if="role=='admin' && !member"/>
                <span v-else-if="role=='admin' && member">{{ member.fullname }} - <a href=""
                                                                                     @click.prevent="member=null">Change</a></span>
                <select v-else-if="role=='user'" class="form-control" v-model="member">
                    <option v-for="(member,index) in memberList" :key="index" :value="member">{{ member.fullname }}
                    </option>
                </select>
            </div>
        </div>

        <!-- /.box-header -->
        <div :class="boxClass.box" v-if="occasionEntity == null">
            <div :class="boxClass.boxHeader">
                <h4 class="box-title">Find Or Create Event</h4>
            </div>
            <div :class="boxClass.boxBody">

                <div :class="accordian.container" id="accordian" aria-multiselectable="false">
                    <div :class="accordian.card">
                        <div :class="accordian.header">

                            <a data-toggle="collapse" data-parent="#accordian" href="#occasionSearchExisting"
                               class="collapsed" aria-expanded="true">
                                <i class="fa fa-plus-circle"></i> Search for an event already in the system
                            </a>
                        </div>
                        <div id="occasionSearchExisting" :class="accordian.collapse" class="in" aria-expanded="true">
                            <div :class="accordian.body">
                                <div class="form-group">
                                    <select class="form-control input-sm" name="year" id="year" v-model="year">
                                        <option value="null">All Years</option>
                                        <option v-for="(year, y) in yearsList" :key="y" :value="year">
                                            {{year}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <v-select label="name" :filterable="false" :options="occasions"
                                              @search="occasionSearch"
                                              placeholder="Type event name.."
                                              v-model="occasion">
                                        <template slot="no-options">
                                            Type to find the event you wish to add a result for
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.name }}<br/>
                                                <small>{{ option.date }}</small>
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.name }}
                                                <small v-if="option.date">{{ option.date }}</small>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="accordian.card" v-if="showAddEvent">
                        <div :class="accordian.header">
                            <a data-toggle="collapse" data-parent="#accordian" href="#occasionSearchNew"
                               class="collapsed" aria-expanded="false">
                                <i class="fa fa-plus-circle"></i> Cant find the event? Add a new one
                            </a>
                        </div>
                        <div id="occasionSearchNew" :class="accordian.collapse" aria-expanded="false">
                            <div :class="accordian.body">
                                <span v-if="theme=='bs3'|| theme=='evt'"
                                      class="btn btn-success btn-block"
                                      data-toggle="modal"
                                      @click="showCreateForm=true"
                                      data-target="#addOccasionModal">
                                        <i class="fa fa-external-link" aria-hidden="true"></i> Add New Event
                                    </span>
                                <span v-else
                                      class="btn btn-success btn-block"
                                      @click="showModal"
                                >
                                        <i class="fa fa-external-link" aria-hidden="true"></i> Add New Event
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div :class="boxClass.box">
            <div :class="boxClass.boxBody">
                <div v-if="hasMember" class="form-group">
                    <label class="col-sm-2 control-label">Member</label>
                    <div class="col-sm-10">
                        <p class="form-control-static">{{ member.fullname }}</p>
                    </div>
                </div>
                <div v-if="hasOccasion" class="form-group">
                    <label class="col-sm-2 control-label">Event</label>
                    <div class="col-sm-10">
                        <p class="form-control-static">{{ occasion.name }}</p>
                    </div>
                </div>
                <div v-if="hasOccasion" class="form-group">
                    <label class="col-sm-2 control-label">Date</label>
                    <div class="col-sm-10">
                        <p class="form-control-static">{{ occasion.date }}</p>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div :class="boxClass.box" v-if="hasOccasion">
                <div :class="boxClass.boxBody">

                    <div class="alert alert-danger alert-dismissible" v-if="errors">
                        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                        {{ errors }}
                    </div>

                    <vue-form-generator :schema="occasion.schema"
                                        :model="values"
                                        :options="formOptions"
                                        @validated="onValidated"
                                        refs="vfg">

                    </vue-form-generator>
                </div>
            </div>
        </transition>
        <!--</form>-->

        <b-modal
            size="lg"
            ref="addEvent"
            :title="'Add Event'"
            ok-text="Close"
            ok-only>
            <occasion-popup-form
                id="bs4"
                v-if="showCreateForm"
                :calendar-id="calendar.id"
                :role="role"
                :theme="theme"
                @occasionAdded="updateOccasion"
            >

            </occasion-popup-form>
        </b-modal>


        <!-- Modal -->
        <div class="modal fade" id="addOccasionModal" tabindex="-1" role="dialog"
             aria-labelledby="addOccasionModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">

                        <h4 class="modal-title" id="addOccasionModalLabel">Add New Event</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <!--TODO - Do we need to select a calendar ID here?-->
                        <occasion-popup-form
                            id="bs3"
                            v-if="showCreateForm"
                            :calendar-id="calendar.id"
                            :role="role"
                            :theme="theme"
                            @occasionAdded="updateOccasion"
                        >

                        </occasion-popup-form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import OccasionPopupForm from '../../Occasions/Form/Popup.vue'
import vSelect from 'vue-select'


import _ from 'lodash'
import VueFormGenerator from "vue-form-generator";
import MemberSearch from "../../AAA_TO_REFACTOR/MemberSearch.vue";


export default {
    name: "add-result",
    components: {MemberSearch, OccasionPopupForm, vSelect},
    props: {
        memberEntity: {
            type: Object,
            default: null,
            required: false
        },
        occasionEntity: {
            type: Object,
            default: null
        },
        calendar: {
            type: Object,
            default: () => ({})
        },
        memberList: {
            type: Array,
            default: () => ([])
        },
        approved: {
            type: Boolean,
            default: false
        },
        redirectUrl: {
            type: String,
            default: '/'
        },
        theme: {
            type: String,
            default: 'bs3'
        },
        role: {
            type: String,
            default: 'user'
        }
    },
    data() {
        return {
            member: this.memberEntity,
            occasion: this.occasionEntity,
            saved: false,
            members: [],
            occasions: [],
            showCreateForm: false,
            values: {
                position: '',
                time: '',
                personalBest: false,
            },
            formOptions: {
                validateAfterLoad: false,
                validateAfterChanged: true
            },
            validated: false,
            errors: '',
            year: null
        }
    },
    computed: {
        hasOccasion: function () {
            return this.occasion !== null && this.occasion.id;
        },
        hasMember: function () {
            return this.member !== null && this.member.id;
        },
        showAddEvent: function () {
            return this.occasion == null || !this.occasion.id;
        },
        calendarId() {
            if (this.calendar !== null) {
                return this.calendar.id;
            }

            return null;
        },
        boxClass() {
            if (this.theme == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    noPadding: 'no-padding'
                }
            } else if (this.theme == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    noPadding: 'no-padding'
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header',
                    boxBody: 'card-body',
                    noPadding: 'px-0 py-0'
                }
            }
        },
        accordian() {
            if (this.theme == 'bs4') {
                return {
                    container: '',
                    card: 'card',
                    header: 'card-header accordion-header',
                    collapse: 'collapse',
                    body: 'card-body'
                }
            } else if (this.theme == 'evt') {
                return {
                    container: 'box-group',
                    card: 'panel box box-primary',
                    header: 'box-header with-border',
                    collapse: 'panel-collapse collapse',
                    body: 'box-body'
                }
            } else {
                return {
                    container: 'panel-group',
                    card: 'panel panel-default',
                    header: 'panel-heading panel-heading-link',
                    collapse: 'panel-collapse collapse in',
                    body: 'panel-body'
                }
            }
        },
        yearsList() {
            const startYear = 1990;
            const endYear = new Date().getFullYear();
            const yearsList = [];
            for (let i = endYear; i >= startYear; i--) {
                yearsList.push(i);
            }

            return yearsList;
        }
    },
    created() {
        if (this.occasionEntity != null) {
            let option = this.getOccasionOption(this.occasionEntity);
            this.occasion = option;
            this.occasions.push(option);
        }
    },
    methods: {
        onValidated(isValid, errors) {
            this.validated = this.hasMember && isValid;
        },
        updateOccasion(value) {

            let option = this.getOccasionOption(value);
            this.showCreateForm = false;
            this.$refs.addEvent.hide();
            this.occasion = option;
            this.occasions.push(option);
            console.log(this.occasion)
            this.getOccasionOption(this.occasion);
            $('#addOccasionModal').modal('hide');
            $('#addOccasionModal').modal('hide');
            $('#occasionSearchExisting').collapse('show');
        },
        memberSearch(search, loading) {
            loading(true);
            this.search('member', search, loading, this);
        },
        //Occasion Search
        occasionSearch(search, loading) {
            loading(true);
            this.search('occasion', search, loading, this);
        },
        search: _.debounce((type, search, loading, vm) => {
            var self = vm;

            vm.occasions = [];

            let yearString = '';

            if (self.year !== null) {
                yearString = `&from_date=01-01-${self.year}&to_date=31-12-${self.year}`;
            }

            axios.get(`/api/internal/occasions.json?name=${search}${yearString}`, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(function (response) {

                if (response.data.data.length > 0) {

                    response.data.data.forEach(function (item) {
                        let option = self.getOccasionOption(item);
                        self.occasions.push(option);
                    });
                }
            });

            loading(false);
        }, 350),
        submit() {

            if (!this.validated) {
                alert('there are validation errors.  Please ensure you selected a member and the required fields')
                return;
            }

            let btn = document.getElementById('submit-btn');

            btn.setAttribute("disabled", "disabled");
            btn.value = "Saving..";

            var additionResultValues = [];

            for (var key in this.values) {

                //If this is not an additional_value continue
                if (key.indexOf('_') <= 0) {
                    continue;
                }

                if (this.values.hasOwnProperty(key)) {
                    let parts = key.split("_");

                    //The ID of the addition
                    let additionId = parts[1];

                    //The value the user entered
                    let value = this.values[key];

                    //If its a fixed otpion input
                    if (parts.length == 3) {
                        //Multiple options
                        //A normal input
                        var additionResultValue = {
                            'addition_id': additionId,
                            'addition_multiple_option_id': value,
                            'service_entity_id': this.occasion.result_type_id //To keep server validation happy
                        }
                    } else {
                        //A normal input
                        var additionResultValue = {
                            'addition_id': additionId,
                            'value': value,
                            'service_entity_id': this.occasion.result_type_id //To keep server validation happy
                        }
                    }
                }

                additionResultValues.push(additionResultValue);
            }

            axios.post('/api/internal/results.json', {
                member_id: this.member.id,
                first_name: this.member.first_name,
                last_name: this.member.last_name,
                user_id: this.member.user_id,
                occasion_id: this.occasion.id,
                position: this.values.position,
                overall_time: this.values.time,
                personal_best: this.values.personalBest,
                club_record_eligible: true,
                big: this.values.bib,
                approval_status: this.approved ? "approved" : "awaiting_approval",
                additional_result_values: additionResultValues
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }).then(response => {
                console.log(response.data.success);
                if (response.data.success) {
                    this.saved = true;
                    window.location.href = this.redirectUrl;
                }
            }).catch(response => {
                this.errors = "You must specify a time if this participant finished";
            });
        },
        showModal() {
            this.showCreateForm = true;
            this.$refs.addEvent.show()
        },
        getOccasionOption(item) {
            console.log(item);
            //Build the array to add to occasions
            let date = item.date ? item.date : item.next_date;
            var option = {};
            option.id = item.id;
            option.name = item.name;
            option.date = moment(date).format('DD/MM/YYYY');
            option.result_type_id = item.result_type_id;

            //let fields = [];

            //const regex = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d).(?:[0-9]\d)/gm;
            const regex = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/gm;

            //If we want to make the standard fields dynamic
            let fields = [
                {
                    type: "input",
                    inputType: "number",
                    label: "Position",
                    model: "position",
                    required: false,
                    min: 0,
                    validator: ["number", "required"]
                },
                {
                    type: "cleave",
                    label: "Finishing Time",
                    model: "time",
                    placeholder: "hh:mm:ss",
                    cleaveOptions: {
                        blocks: [2, 2, 2],
                        delimiters: [':', ':'],
                        numericOnly: true,
                        uppercase: false,
                        lowercase: false
                    },
                    required: true,
                    pattern: regex,
                    validator: [VueFormGenerator.validators.regexp]
                },
                {
                    type: "checkbox",
                    label: "Personal Best",
                    model: "personalBest",
                },
            ];

            if (item.hasOwnProperty('result_type') && item['result_type']) {
                item.result_type.result_type_additions.forEach(function (resultTypeAddition) {

                    var formItem = {};
                    var multipleValues = [];

                    formItem.model = 'addition_' + resultTypeAddition.addition.id;
                    formItem.label = resultTypeAddition.addition.name;
                    formItem.type = resultTypeAddition.addition.data_type.vue_form_generator_type;
                    formItem.inputType = resultTypeAddition.addition.data_type.vue_form_generator_input_type;
                    formItem.required = resultTypeAddition.mandatory;

                    //Todo - make this this exists
                    if (resultTypeAddition.addition.data_type.vue_form_generator_type == "select") {
                        resultTypeAddition.addition.addition_multiple_options.forEach(function (additionMultipleOption) {
                            multipleValues.push(additionMultipleOption);
                        });

                        formItem.values = multipleValues;
                        formItem.model = 'addition_' + resultTypeAddition.addition.id + '_multiple';
                    }
                    if (resultTypeAddition.addition.data_type.vue_form_generator_type == "mask") {
                        formItem.type = "cleave";
                        formItem.placeholder = "hh:mm:ss";
                        formItem.cleaveOptions = {
                            blocks: [2, 2, 2],
                            delimiters: [':', ':'],
                            numericOnly: true,
                            uppercase: false,
                            lowercase: false
                        };
                        formItem.pattern = regex;
                        formItem.validator = [VueFormGenerator.validators.regexp];
                    }

                    //hint: "Minimum 6 characters",
                    if (resultTypeAddition.addition.data_type.vue_form_generator_validator) {
                        formItem.validator = resultTypeAddition.addition.data_type.vue_form_generator_validator;
                    }
                    fields.push(formItem);
                });
            } else {
                console.log('show the result_templates select');
            }

            option.schema = {};

            //Add the submit button at the end
            fields.push({
                type: "submit",
                id: 'submit-btn',
                buttonText: "Save Result",
                validateBeforeSubmit: true, //this does not work
                onSubmit: this.submit
            })

            option.schema.fields = fields;
            return option;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/Results/Form/Add.vue